define("shared/components/shared/ui/profile-color-option", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    class="{{if (eq @socialProfile.profileColorClass @colorClass) 'is--active'}} {{profile-color-class @colorClass}}"
    onclick={{action @trackSelection @socialProfile @colorClass}}
  >
  </div>
  */
  {
    "id": "ddMOML/j",
    "block": "[[[10,0],[15,0,[29,[[52,[28,[37,1],[[30,1,[\"profileColorClass\"]],[30,2]],null],\"is--active\"],\" \",[28,[37,2],[[30,2]],null]]]],[15,\"onclick\",[28,[37,3],[[30,0],[30,3],[30,1],[30,2]],null]],[12],[1,\"\\n\"],[13]],[\"@socialProfile\",\"@colorClass\",\"@trackSelection\"],false,[\"if\",\"eq\",\"profile-color-class\",\"action\"]]",
    "moduleName": "shared/components/shared/ui/profile-color-option.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});